// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.search-result-box{
    /*border: 1px solid;*/
    float:left;
    z-index: 1000;
    position: fixed;
    background-color: var(--white-color);
    box-shadow: var(--shadow-pb);
    mix-blend-mode: normal;
    width: inherit;
    padding-bottom: 16px;
    border-radius: 0px 0px 6px 6px;
}

.search-result-box__more.baloa-names{

    display: flex;
    align-items: center;
    color: var(--new-green-color);
    padding: 16px 8px;
}

.search-result-box__result {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    gap: 16px;
    margin: 16px 16px 0 16px;
    width: initial;
}
.search-result-box__result:hover{
    background-color: var(--hover-sb-bg-color);
}

.hide {
    display: none;
 }

.search-result-box__result__profile-info {
    display: flex;
    align-items: center;
    width: 100%;
}

.search-result-box__result__profile-info__photo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.search-result-box__result__profile-info__photo img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.search-result-box__result__profile-info__photo .icon-ball {
    font-size: 32px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 4px;
    color: var(--white-color);
}

.search-result-box__result__profile-info__data {
    display: flex;
    flex-direction: column;
    width: inherit;
    max-width: calc(100% - 50px);
}

.search-result-box__result__profile-info__data__fullname {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
}

.search-result-box__result__profile-info__data__fullname-name {
    width: 100%;
}
.search-result-box__result__profile-info__data__fullname-name.baloa-names {
    color: var(--primary-very-dark-color);
    overflow: hidden;
    white-space: nowrap; /* Don't forget this one */
    text-overflow: ellipsis;
}

.search-result-box__result__profile-info__data__username.baloa-table-column {
    color: var(--basic-gray-color);
    font-weight: var(--font-regular);
    overflow: hidden;
    white-space: nowrap; /* Don't forget this one */
    text-overflow: ellipsis;
}
.search-result-box__result__follow-button button{
    padding: calc( var(--space-quarter) / 2 ) !important;
}

/* Small */

.search-result-box.sm .search-result-box__result {
    background-color: var(--white-color);
    flex-direction: column;
    padding: var(--space);
    border-radius: 4px;
    box-shadow: var(--shadow-card-1);
    width: 100%;
    margin-bottom: var(--space);
}
.search-result-box.sm .search-result-box__result__profile-info {
    align-self: flex-start;
    align-items: flex-start;
}
.search-result-box.sm .search-result-box__result__profile-info__photo {
    border-radius: 8px;
}

.search-result-box.sm .search-result-box__result__profile-info__data__username {
    font-size: var(--font-small);
    letter-spacing: 0.004em;
    font-weight: var(--font-bold) !important;
}
.search-result-box.sm .search-result-box__result__follow-button {
    margin-top: var(--space-quarter);
    align-self: flex-end;
}

/* Mobile */

.search-result-box.mv .search-result-box__result {
    flex-direction: column;
    align-content: center;
}

.search-result-box.mv .search-result-box__result__profile-info {
    flex-direction: column;
    align-self: auto;
    align-items: center;
}

.search-result-box.mv .search-result-box__result__profile-info__photo {
    margin: 0;
}

.search-result-box.mv .search-result-box__result__profile-info__data {
    margin: 0;
}

.search-result-box.mv .search-result-box__result__follow-button {
    align-self: auto;
}

/*=================*/
.search-result-box__link-buttons__container {
    padding: 16px;
}

.search-result-box__link-buttons__subtitle.baloa-names {
    color: var(--basic-gray-color);
    margin-bottom: 8px;
}

.search-result-box__link-buttons__buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.search-result-box__link-buttons__button{
    display: flex;
    align-items: center;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 4px;
    padding: 12px 8px 12px 12px;
    gap: 8px;
    cursor: pointer;
    background: var(--white-color);
}

.search-result-box__link-buttons__button .baloa-names {
    color: var(--primary-very-dark-color);
}

.search-result-box__link-buttons__button .icon-chevron-roght {
    margin-left: auto;
    color: var(--basic-gray-color);
    font-size: 20px;
}

.search-result-box__link-buttons__button .icon-player, 
.search-result-box__link-buttons__button .icon-coach {
    color: var(--white-color);
    background: #EB3B3B;
    border-radius: 50%;
    padding: 2px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.search-result-box__link-buttons__button .hubicon-tournaments,
.search-result-box__link-buttons__button .hubicon-pages {
    font-size: 20px;
}

.search-result-box__more {
    border-bottom: 1px solid var(--new-gray-background-color);
}

a.search-result-box__more svg {
    position: unset;
}

a.search-result-box__more .MuiSvgIcon-root {
    fill: var(--new-green-color);
    margin: 0 8px;
}

.search-result-box__result__profile-info__data-type {
    background: var(--new-grey-light-background-color);
    border: 1px solid var(--new-gray-border-color);
    border-radius: 6px;
    padding: 2px 4px;
    margin-left: auto;
}

.search-result-box__result__profile-info__data-type.baloa-mini {
    color: var(--primary-very-dark-color);
}

@media screen and ( max-width: 576px ) {
    
    .search-result-box__result {
        width: 100%;
    }

}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 
    div.search-result-box {
        width: 100%;
        position: absolute;
        left: 0;
        height: 100vh;
        margin-top: 6px;
    }

    .search-result-box__more {
        border-top: 1px solid var(--new-gray-background-color);
    }

    .search-result-box__link-buttons__button {
        padding: 8px 8px 8px 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/search/components/search-result-box/SearchResultBoxComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,UAAU;IACV,aAAa;IACb,eAAe;IACf,oCAAoC;IACpC,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;IACd,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,wBAAwB;IACxB,cAAc;AAClB;AACA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;CAChB;;AAED;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;AACA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB,EAAE,0BAA0B;IAC/C,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB,EAAE,0BAA0B;IAC/C,uBAAuB;AAC3B;AACA;IACI,oDAAoD;AACxD;;AAEA,UAAU;;AAEV;IACI,oCAAoC;IACpC,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,wCAAwC;AAC5C;AACA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA,WAAW;;AAEX;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kDAAkD;IAClD,kBAAkB;IAClB,2BAA2B;IAC3B,QAAQ;IACR,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,kDAAkD;IAClD,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI;QACI,WAAW;IACf;;AAEJ;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,sDAAsD;IAC1D;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["div.search-result-box{\n    /*border: 1px solid;*/\n    float:left;\n    z-index: 1000;\n    position: fixed;\n    background-color: var(--white-color);\n    box-shadow: var(--shadow-pb);\n    mix-blend-mode: normal;\n    width: inherit;\n    padding-bottom: 16px;\n    border-radius: 0px 0px 6px 6px;\n}\n\n.search-result-box__more.baloa-names{\n\n    display: flex;\n    align-items: center;\n    color: var(--new-green-color);\n    padding: 16px 8px;\n}\n\n.search-result-box__result {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 auto;\n    gap: 16px;\n    margin: 16px 16px 0 16px;\n    width: initial;\n}\n.search-result-box__result:hover{\n    background-color: var(--hover-sb-bg-color);\n}\n\n.hide {\n    display: none;\n }\n\n.search-result-box__result__profile-info {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.search-result-box__result__profile-info__photo {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    margin-right: 10px;\n}\n\n.search-result-box__result__profile-info__photo img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n.search-result-box__result__profile-info__photo .icon-ball {\n    font-size: 32px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 4px;\n    color: var(--white-color);\n}\n\n.search-result-box__result__profile-info__data {\n    display: flex;\n    flex-direction: column;\n    width: inherit;\n    max-width: calc(100% - 50px);\n}\n\n.search-result-box__result__profile-info__data__fullname {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.search-result-box__result__profile-info__data__fullname-name {\n    width: 100%;\n}\n.search-result-box__result__profile-info__data__fullname-name.baloa-names {\n    color: var(--primary-very-dark-color);\n    overflow: hidden;\n    white-space: nowrap; /* Don't forget this one */\n    text-overflow: ellipsis;\n}\n\n.search-result-box__result__profile-info__data__username.baloa-table-column {\n    color: var(--basic-gray-color);\n    font-weight: var(--font-regular);\n    overflow: hidden;\n    white-space: nowrap; /* Don't forget this one */\n    text-overflow: ellipsis;\n}\n.search-result-box__result__follow-button button{\n    padding: calc( var(--space-quarter) / 2 ) !important;\n}\n\n/* Small */\n\n.search-result-box.sm .search-result-box__result {\n    background-color: var(--white-color);\n    flex-direction: column;\n    padding: var(--space);\n    border-radius: 4px;\n    box-shadow: var(--shadow-card-1);\n    width: 100%;\n    margin-bottom: var(--space);\n}\n.search-result-box.sm .search-result-box__result__profile-info {\n    align-self: flex-start;\n    align-items: flex-start;\n}\n.search-result-box.sm .search-result-box__result__profile-info__photo {\n    border-radius: 8px;\n}\n\n.search-result-box.sm .search-result-box__result__profile-info__data__username {\n    font-size: var(--font-small);\n    letter-spacing: 0.004em;\n    font-weight: var(--font-bold) !important;\n}\n.search-result-box.sm .search-result-box__result__follow-button {\n    margin-top: var(--space-quarter);\n    align-self: flex-end;\n}\n\n/* Mobile */\n\n.search-result-box.mv .search-result-box__result {\n    flex-direction: column;\n    align-content: center;\n}\n\n.search-result-box.mv .search-result-box__result__profile-info {\n    flex-direction: column;\n    align-self: auto;\n    align-items: center;\n}\n\n.search-result-box.mv .search-result-box__result__profile-info__photo {\n    margin: 0;\n}\n\n.search-result-box.mv .search-result-box__result__profile-info__data {\n    margin: 0;\n}\n\n.search-result-box.mv .search-result-box__result__follow-button {\n    align-self: auto;\n}\n\n/*=================*/\n.search-result-box__link-buttons__container {\n    padding: 16px;\n}\n\n.search-result-box__link-buttons__subtitle.baloa-names {\n    color: var(--basic-gray-color);\n    margin-bottom: 8px;\n}\n\n.search-result-box__link-buttons__buttons {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.search-result-box__link-buttons__button{\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 4px;\n    padding: 12px 8px 12px 12px;\n    gap: 8px;\n    cursor: pointer;\n    background: var(--white-color);\n}\n\n.search-result-box__link-buttons__button .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.search-result-box__link-buttons__button .icon-chevron-roght {\n    margin-left: auto;\n    color: var(--basic-gray-color);\n    font-size: 20px;\n}\n\n.search-result-box__link-buttons__button .icon-player, \n.search-result-box__link-buttons__button .icon-coach {\n    color: var(--white-color);\n    background: #EB3B3B;\n    border-radius: 50%;\n    padding: 2px;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n}\n\n.search-result-box__link-buttons__button .hubicon-tournaments,\n.search-result-box__link-buttons__button .hubicon-pages {\n    font-size: 20px;\n}\n\n.search-result-box__more {\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\na.search-result-box__more svg {\n    position: unset;\n}\n\na.search-result-box__more .MuiSvgIcon-root {\n    fill: var(--new-green-color);\n    margin: 0 8px;\n}\n\n.search-result-box__result__profile-info__data-type {\n    background: var(--new-grey-light-background-color);\n    border: 1px solid var(--new-gray-border-color);\n    border-radius: 6px;\n    padding: 2px 4px;\n    margin-left: auto;\n}\n\n.search-result-box__result__profile-info__data-type.baloa-mini {\n    color: var(--primary-very-dark-color);\n}\n\n@media screen and ( max-width: 576px ) {\n    \n    .search-result-box__result {\n        width: 100%;\n    }\n\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n    div.search-result-box {\n        width: 100%;\n        position: absolute;\n        left: 0;\n        height: 100vh;\n        margin-top: 6px;\n    }\n\n    .search-result-box__more {\n        border-top: 1px solid var(--new-gray-background-color);\n    }\n\n    .search-result-box__link-buttons__button {\n        padding: 8px 8px 8px 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
